import { StateToken } from '@ngxs/store';
import { ITaskParticipationState } from './task-participation.state';

export const TASK_PARTICIPATION_STATE_TOKEN = new StateToken<ITaskParticipationState>('taskParticipation');
